import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Button } from 'ayvri-ui/lib/button';

import PlayerState from '../../PlayerState';
import style from './playerHeader.css';
import { buildAssetUrl } from '../../helpers';

const logoColor = 'assets/images/logos/ayvri-logo-color.svg';

const Logo = ({ playerStarted }) => (
  <a href='http://ayvri.com' className={`${style.logo} hideOnWebsite`}>
    <img className={!playerStarted ? style.colorLogo : null} src={buildAssetUrl(logoColor)} alt='Ayvri logo' />
  </a>
);

const CreditsContainer = () => (
  <div className={style.credits}>
    <span className='creditContainer' />
  </div>
);

const IntegrationLogo = ({ integrations }) => {
  // For now, only display a single integration, even though there may be multiple
  const integration = integrations.find(i => i.appIconUrl);

  if (!integration) return null;
  return (
    <a href={integration.companyUrl} className={`${style.logo} ${style.integration}`}>
      <img src={integration.appIconUrl} alt={`${integration.name} logo`} />
    </a>
  );
};

const DevModeDisclaimer = () => <div className={style.devMode}>Dev Mode</div>;

const Header = ({ isDevMode, playerStarted, integrations, showCreateMore }) => (
  <div>
    <div className={style.logoHolder}>
      <Logo playerStarted={playerStarted} />
      <IntegrationLogo integrations={integrations} />
      <CreditsContainer />
      {isDevMode ? <DevModeDisclaimer /> : ''}
      {showCreateMore ? (
        <div className={style.promoButton}>
          <Button
            size='small'
            type='outline'
            onClick={() => {
              window.open('/', '_new');
            }}
          >
            Create Your Own
          </Button>
        </div>
      ) : null}
    </div>
  </div>
);

const accountTypeSelector = state => state.scene.accountType;
const isEmbedSelector = state => state.layout.isEmbed;
const isMobileSelector = state => state.layout.isMobile;

const showCreateMoreSelector = createSelector(
  accountTypeSelector,
  isEmbedSelector,
  isMobileSelector,
  (accountType, isEmbed, isMobile) => {
    // Show the "Create Your Own" button if this is an embedded, non-API created scene viewed on desktop
    const isUserAccount = accountType !== 'api';
    return isEmbed && isUserAccount && !isMobile;
  },
);

const mapStateToProps = state => ({
  isDevMode: state.scene.devMode,
  showCreateMore: showCreateMoreSelector(state),
  playerStarted: state.loading.playerState >= PlayerState.LOADING,
  integrations: state.scene.integrations,
});

export default connect(mapStateToProps)(Header);
